/* Add semantic styling hooks to native information bodies. Merchant facts and clause text are never rewritten here. */
(function(){
 function prepare(){
  if(!document.body.matches('.template-page,.template-policy'))return;
  const main=document.querySelector('#MainContent');if(!main)return;
  main.querySelectorAll('.rte,.shopify-policy__body,.family-information,.family-contact-body').forEach(body=>{
   body.classList.add('family-information');
   body.querySelectorAll('.policy-fact-row,[data-policy-fact]').forEach(row=>row.classList.add('family-fact-row'));
   body.querySelectorAll('p,h1,h2,h3,h4,h5,h6').forEach(row=>{if(/^last updated\s*:/i.test(row.textContent.trim()))row.classList.add('family-last-updated');});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',prepare,{once:true});else prepare();
})();
